var React = require('react');

function IcAwsOpsworksStack2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Art"},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M39.149,40H0.851C0.381,40,0,39.619,0,39.149V0.851C0,0.381,0.381,0,0.851,0h38.298\n\t\t\tC39.619,0,40,0.381,40,0.851v38.298C40,39.619,39.619,40,39.149,40z M1.702,38.298h36.596V1.702H1.702V38.298z"}))));
}

IcAwsOpsworksStack2.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsOpsworksStack2;

IcAwsOpsworksStack2.default = IcAwsOpsworksStack2;
